import React from 'react';
import styled from 'styled-components';
import {
    Convenience_and_ease_of_use,
    Find_your_ideal_client,
    Focus_on_the_right_customers,
    Increase_your_rating_and_get_more_orders,
    Promote_your_candidacy_with_our_guides,
    Start_taking_orders_continuously,
    Study_the_desires_and_requirements,
} from '../../helpers/dictionary';

const InformationCss = styled.ul`
  background-color: white;
  padding: 0 1.6rem;
  h2 {
    text-align: center;
    font-weight: 600;
    font-size: 34px;
    line-height: 33px;
    margin-bottom: 0;
    margin-top: 6rem;
  }
  .flex-content {
    padding: 4rem 0;
    margin: 0;
    .column {
      margin-bottom: 4rem;
      text-align: center;
      h3 {
        font-weight: 600;
        font-size: 16px;
        color: var(--color-flickr-blue);
      }
      p {
        padding: 0;
        margin: 0;
        font-size: 15px;
        line-height: 18px;
        color: #565459;
      }
    }
  }
  @media (min-width: 768px) {
    padding: 0 3.2rem;
  }
  @media (min-width: 1024px) {
    max-width: 946px;
    margin: auto;
    .flex-content {
      display: flex;
      justify-content: space-between;
      padding: 9.2rem 0;
      .column {
        flex: 0 0 30%;
        margin-bottom: 0;
        h3 {
          font-size: 20px;
        }
      }
    }
  }
`;

const Information = ({ lang }) => {
    return (
        <InformationCss>
            <h2>{Find_your_ideal_client[lang]}</h2>
            <div className="flex-content">
                <div className="column">
                    <div className="icon">
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="40" cy="40" r="40" fill="#F4F6FB" />
                            <g clipPath="url(#clip0)">
                                <path
                                    opacity="0.4"
                                    d="M63.7875 33.9744C63.9241 34.1154 63.9999 34.3044 63.9987 34.5007C63.9976 34.697 63.9195 34.8851 63.7812 35.0244L54.95 43.7869C54.8807 43.8556 54.7985 43.9099 54.7082 43.9468C54.6179 43.9837 54.5212 44.0024 54.4237 44.0018C54.3261 44.0012 54.2297 43.9814 54.1398 43.9434C54.0499 43.9055 53.9684 43.8502 53.9 43.7807L48.7937 38.6369C48.725 38.5677 48.6707 38.4855 48.6338 38.3952C48.597 38.3049 48.5783 38.2082 48.5789 38.1106C48.5795 38.0131 48.5993 37.9166 48.6372 37.8267C48.6752 37.7369 48.7305 37.6554 48.8 37.5869L50.5562 35.8432C50.6255 35.7745 50.7076 35.7202 50.798 35.6833C50.8883 35.6464 50.985 35.6278 51.0825 35.6283C51.1801 35.6289 51.2765 35.6487 51.3664 35.6867C51.4563 35.7246 51.5378 35.7799 51.6062 35.8494L54.45 38.7119L61 32.2119C61.0692 32.1432 61.1514 32.0889 61.2417 32.052C61.332 32.0152 61.4287 31.9965 61.5263 31.9971C61.6238 31.9977 61.7203 32.0175 61.8102 32.0554C61.9 32.0934 61.9815 32.1487 62.05 32.2182L63.7875 33.9744Z"
                                    fill="#858A8F"
                                />
                                <path
                                    d="M38 40C39.5823 40 41.129 39.5308 42.4446 38.6518C43.7602 37.7727 44.7855 36.5233 45.391 35.0615C45.9965 33.5997 46.155 31.9911 45.8463 30.4393C45.5376 28.8874 44.7757 27.462 43.6569 26.3431C42.538 25.2243 41.1126 24.4624 39.5607 24.1537C38.0089 23.845 36.4003 24.0035 34.9385 24.609C33.4767 25.2145 32.2273 26.2398 31.3482 27.5554C30.4692 28.871 30 30.4178 30 32C30 34.1217 30.8429 36.1566 32.3431 37.6569C33.8434 39.1571 35.8783 40 38 40ZM43.6 42H42.5562C41.1277 42.6588 39.5732 43 38 43C36.4268 43 34.8723 42.6588 33.4438 42H32.4C30.1723 42.0005 28.036 42.8857 26.4609 44.4609C24.8857 46.0361 24.0005 48.1723 24 50.4V53C24 53.7957 24.3161 54.5587 24.8787 55.1213C25.4413 55.6839 26.2044 56 27 56H49C49.7956 56 50.5587 55.6839 51.1213 55.1213C51.6839 54.5587 52 53.7957 52 53V50.4C51.9995 48.1723 51.1143 46.0361 49.5391 44.4609C47.964 42.8857 45.8277 42.0005 43.6 42Z"
                                    fill="#858A8F"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect
                                        width="40"
                                        height="32"
                                        fill="white"
                                        transform="translate(24 24)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <h3>{Focus_on_the_right_customers[lang]}</h3>
                    <p>{Study_the_desires_and_requirements[lang]}</p>
                </div>
                <div className="column">
                    <div className="icon">
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="40" cy="40" r="40" fill="#F4F6FB" />
                            <path
                                opacity="0.3"
                                d="M48.9568 40.063L41.6668 38.6763V30.833C41.6668 29.453 40.5468 28.333 39.1668 28.333C37.7868 28.333 36.6668 29.453 36.6668 30.833V45.328L31.5368 42.9347C30.6118 42.503 29.5135 42.7097 28.8085 43.448L27.3418 44.9847L36.3801 54.023C37.0051 54.648 37.8535 54.9997 38.7385 54.9997H48.3335C50.1751 54.9997 51.6668 53.508 51.6668 51.6663V43.338C51.6668 41.7363 50.5285 40.3613 48.9568 40.063Z"
                                fill="#858A8F"
                            />
                            <path
                                d="M48.3334 56.667H38.7384C37.4034 56.667 36.1467 56.147 35.2017 55.202L25.0117 45.012L27.6034 42.2987C28.8034 41.042 30.6634 40.6903 32.2417 41.427L35.0001 42.712V30.8337C35.0001 28.537 36.8701 26.667 39.1667 26.667C41.4634 26.667 43.3334 28.537 43.3334 30.8337V37.297L49.2667 38.4253C51.6234 38.8737 53.3334 40.9387 53.3334 43.337V51.667C53.3334 54.4237 51.0901 56.667 48.3334 56.667ZM29.6717 44.9587L37.5584 52.8453C37.8734 53.1603 38.2934 53.3337 38.7384 53.3337H48.3334C49.2517 53.3337 50.0001 52.5853 50.0001 51.667V43.337C50.0001 42.5387 49.4301 41.8487 48.6451 41.7003L40.0001 40.057V30.8337C40.0001 30.3737 39.6267 30.0003 39.1667 30.0003C38.7067 30.0003 38.3334 30.3737 38.3334 30.8337V47.9453L30.8334 44.447C30.5567 44.3187 30.2284 44.3787 30.0151 44.6003L29.6717 44.9587Z"
                                fill="#858A8F"
                            />
                            <path
                                d="M42.225 37.7783L41.1083 34.6367C43.4367 33.81 45 31.6117 45 29.1667C45 25.95 42.3833 23.3333 39.1667 23.3333C35.95 23.3333 33.3333 25.95 33.3333 29.1667C33.3333 31.6117 34.8967 33.81 37.225 34.6367L36.1083 37.7783C32.455 36.4783 30 33.0183 30 29.1667C30 24.1117 34.1117 20 39.1667 20C44.2217 20 48.3333 24.1117 48.3333 29.1667C48.3333 33.0183 45.8783 36.4783 42.225 37.7783Z"
                                fill="#858A8F"
                            />
                        </svg>
                    </div>
                    <h3>{Start_taking_orders_continuously[lang]}</h3>
                    <p>{Increase_your_rating_and_get_more_orders[lang]}</p>
                </div>
                <div className="column">
                    <div className="icon">
                        <svg
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="40" cy="40" r="40" fill="#F4F6FB" />
                            <g clipPath="url(#clip0)">
                                <path
                                    opacity="0.4"
                                    d="M60 39.9997C60 38.6002 59.573 37.234 58.7758 36.0837C57.9787 34.9333 56.8495 34.0537 55.5391 33.5622C56.1171 32.2885 56.2928 30.8687 56.0428 29.4924C55.7928 28.1162 55.129 26.8489 54.1399 25.8598C53.1508 24.8708 51.8835 24.2069 50.5073 23.9569C49.131 23.7069 47.7112 23.8826 46.4375 24.4607C45.9462 23.1501 45.0666 22.0207 43.9162 21.2235C42.7659 20.4262 41.3996 19.999 40 19.999C38.6004 19.999 37.2341 20.4262 36.0837 21.2235C34.9334 22.0207 34.0538 23.1501 33.5625 24.4607C32.2887 23.8826 30.869 23.7069 29.4927 23.9569C28.1164 24.2069 26.8492 24.8708 25.8601 25.8598C24.871 26.8489 24.2071 28.1162 23.9571 29.4924C23.7071 30.8687 23.8829 32.2885 24.4609 33.5622C23.1504 34.0536 22.021 34.9332 21.2237 36.0835C20.4264 37.2338 19.9993 38.6001 19.9993 39.9997C19.9993 41.3994 20.4264 42.7656 21.2237 43.916C22.021 45.0663 23.1504 45.9459 24.4609 46.4372C23.8829 47.711 23.7071 49.1308 23.9571 50.507C24.2071 51.8833 24.871 53.1506 25.8601 54.1396C26.8492 55.1287 28.1164 55.7926 29.4927 56.0426C30.869 56.2926 32.2887 56.1168 33.5625 55.5388C34.0538 56.8494 34.9334 57.9787 36.0837 58.776C37.2341 59.5733 38.6004 60.0005 40 60.0005C41.3996 60.0005 42.7659 59.5733 43.9162 58.776C45.0666 57.9787 45.9462 56.8494 46.4375 55.5388C47.7112 56.1168 49.131 56.2926 50.5073 56.0426C51.8835 55.7926 53.1508 55.1287 54.1399 54.1396C55.129 53.1506 55.7928 51.8833 56.0428 50.507C56.2928 49.1308 56.1171 47.711 55.5391 46.4372C56.8495 45.9458 57.9787 45.0662 58.7758 43.9158C59.573 42.7655 60 41.3993 60 39.9997ZM48.6875 36.5427L38.4531 46.699C38.2913 46.8594 38.0725 46.949 37.8447 46.9481C37.6169 46.9472 37.3988 46.8559 37.2383 46.6943L31.3226 40.731C31.2431 40.6509 31.1801 40.5559 31.1373 40.4514C31.0945 40.347 31.0727 40.2351 31.0731 40.1222C31.0736 40.0093 31.0962 39.8976 31.1399 39.7935C31.1835 39.6894 31.2472 39.5949 31.3273 39.5154L33.3594 37.4997C33.4395 37.4202 33.5345 37.3572 33.6389 37.3144C33.7434 37.2716 33.8553 37.2498 33.9681 37.2502C34.081 37.2507 34.1927 37.2733 34.2969 37.317C34.401 37.3606 34.4955 37.4243 34.575 37.5044L37.868 40.824L45.4617 33.2912C45.6235 33.1308 45.8423 33.0412 46.0701 33.042C46.2979 33.0429 46.516 33.1342 46.6765 33.2958L48.6937 35.3271C48.7732 35.4073 48.836 35.5024 48.8787 35.6069C48.9214 35.7114 48.943 35.8233 48.9425 35.9362C48.9419 36.0491 48.9191 36.1608 48.8753 36.2648C48.8316 36.3689 48.7677 36.4633 48.6875 36.5427Z"
                                    fill="#858A8F"
                                />
                                <path
                                    d="M48.6874 36.5427L38.453 46.6989C38.2912 46.8593 38.0724 46.9489 37.8446 46.948C37.6168 46.9471 37.3987 46.8559 37.2381 46.6942L31.3225 40.7309C31.243 40.6508 31.18 40.5558 31.1372 40.4514C31.0944 40.3469 31.0726 40.2351 31.073 40.1222C31.0734 40.0093 31.0961 39.8976 31.1397 39.7935C31.1833 39.6893 31.247 39.5948 31.3272 39.5153L33.3592 37.4997C33.4393 37.4202 33.5343 37.3572 33.6388 37.3144C33.7433 37.2716 33.8551 37.2498 33.968 37.2502C34.0809 37.2506 34.1926 37.2733 34.2967 37.3169C34.4008 37.3605 34.4954 37.4242 34.5749 37.5044L37.8678 40.8239L45.4616 33.2911C45.6233 33.1307 45.8422 33.0411 46.07 33.042C46.2978 33.0429 46.5159 33.1342 46.6764 33.2958L48.6936 35.327C48.7731 35.4072 48.8361 35.5022 48.8789 35.6066C48.9217 35.7111 48.9435 35.8229 48.9431 35.9358C48.9427 36.0487 48.92 36.1604 48.8764 36.2645C48.8328 36.3687 48.7691 36.4632 48.6889 36.5427H48.6874Z"
                                    fill="#858A8F"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect
                                        width="40"
                                        height="40"
                                        fill="white"
                                        transform="translate(20 20)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <h3>{Convenience_and_ease_of_use[lang]}</h3>
                    <p>{Promote_your_candidacy_with_our_guides[lang]}</p>
                </div>
            </div>
        </InformationCss>
    );
};

export default Information;
